import { Bar } from 'react-chartjs-2';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { CircularProgress } from '@chakra-ui/react';

const WEEKDAY_LABELS = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];

/** Django `__week_day`: 1=Sunday … 7=Saturday → index in WEEKDAY_LABELS (Mon-first). */
function djangoWeekDayToIndex(weekDay: number): number {
  return weekDay === 1 ? 6 : weekDay - 2;
}

export const WeekdayUsageGraph = ({
  weekdayUsage,
  height = '60px',
}: {
  weekdayUsage?: { createdAtWeekDay: number; usage: number }[];
  height?: string;
}) => {
  const { colors } = useTheme();

  if (!weekdayUsage) return <CircularProgress isIndeterminate />;

  const usageByDay = Array(7).fill(0);
  weekdayUsage.forEach(({ createdAtWeekDay, usage }) => {
    const index = djangoWeekDayToIndex(createdAtWeekDay);
    if (index >= 0 && index < 7) usageByDay[index] = usage;
  });

  return (
    <Bar
      width="100%"
      height={height}
      data={{
        labels: WEEKDAY_LABELS,
        datasets: [
          {
            label: 'Dia da Semana',
            data: usageByDay,
            borderColor: colors.graphColors,
            backgroundColor: colors.graphColors,
            borderWidth: 1,
          },
        ],
      }}
    />
  );
};
